import React from 'react';
import { ChevronDown } from 'lucide-react';
import { companyInfo, heroImage } from '../data/mock';

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Luxury Private Jet Interior"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#2c2825]/70 via-[#2c2825]/50 to-[#2c2825]/80" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 text-center">
        <div className="opacity-0 animate-fade-in-up" style={{ animationDelay: '0.2s', animationFillMode: 'forwards' }}>
          <h1 className="font-display text-4xl md:text-6xl lg:text-7xl text-[#faf8f5] mb-4 tracking-wide" style={{ fontWeight: 400 }}>
            {companyInfo.name}
          </h1>
          <p className="text-lg md:text-xl text-[#c9b896] mb-2 tracking-widest">
            {companyInfo.nameArabic}
          </p>
        </div>

        <div className="opacity-0 animate-fade-in-up" style={{ animationDelay: '0.5s', animationFillMode: 'forwards' }}>
          <p className="font-display text-2xl md:text-3xl lg:text-4xl text-[#faf8f5] mt-8 mb-4" style={{ fontWeight: 300 }}>
            {companyInfo.tagline}
          </p>
        </div>

        <div className="opacity-0 animate-fade-in-up" style={{ animationDelay: '0.8s', animationFillMode: 'forwards' }}>
          <p className="text-sm md:text-base text-[#faf8f5]/80 tracking-[0.3em] uppercase mt-6">
            {companyInfo.subtitle}
          </p>
        </div>

        <div className="opacity-0 animate-fade-in-up" style={{ animationDelay: '1.1s', animationFillMode: 'forwards' }}>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-12">
            <a
              href="#careers"
              className="inline-flex items-center justify-center px-10 py-4 border border-[#c9b896] text-[#c9b896] text-sm tracking-widest uppercase hover:bg-[#c9b896] hover:text-[#2c2825] transition-all duration-300"
            >
              View Opportunities
            </a>
            <a
              href={`mailto:${companyInfo.email}?subject=CV Submission - SaraPrivéAviation`}
              className="inline-flex items-center justify-center px-10 py-4 bg-[#c9b896] text-[#2c2825] text-sm tracking-widest uppercase hover:bg-[#d4c4a8] transition-all duration-300"
            >
              Send Your CV
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 opacity-0 animate-fade-in" style={{ animationDelay: '1.5s', animationFillMode: 'forwards' }}>
        <a href="#about" className="flex flex-col items-center text-[#faf8f5]/60 hover:text-[#c9b896] transition-colors">
          <span className="text-xs tracking-widest uppercase mb-2">Discover</span>
          <ChevronDown size={20} className="animate-bounce" />
        </a>
      </div>
    </section>
  );
};

export default Hero;
